import React, { useEffect, useState, useRef } from "react";
import { Row, Col, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import LeaveViewController from "../../redux/actions/leaveApiAction";
import ReusableGrid from "../../components/ag grid/ReusableGrid";
import ExportButton from "../../components/ag grid/ExportButton";

import "../../styles/styles.css";
import "../../styles/layout.css";

const LeaveBalanceList = () => {
  const dispatch = useDispatch();
  const gridRef = useRef(null);
  const { getLeaveBalance } = LeaveViewController();
  const { leaveBalance } = useSelector((state) => state.leave);

  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    dispatch(getLeaveBalance());
  }, [dispatch]);

  const generateLeaveYears = () => {
    const currentYear = new Date().getFullYear();
    const startYear = 2020;
    const years = [];
    for (let year = currentYear; year >= startYear; year--) {
      years.push(year);
    }
    return years;
  };

  const filteredData =
    leaveBalance?.filter((balance) => balance.leave_year === selectedYear) ||
    [];

  const columnDefs = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      maxWidth: 50,
      pinned: "left"
    },
    {
      headerName: "SR.No",
      valueGetter: (params) => params.node.rowIndex + 1,
      maxWidth: 80
    },
    {
      headerName: "Emp ID",
      field: "employee.employee_id",
      valueGetter: (params) => params.data.employee?.employee_id || "N/A",
      flex: 1
    },
    {
      headerName: "Employee",
      valueGetter: (params) =>
        `${params.data.employee?.first_name || ""} ${
          params.data.employee?.last_name || ""
        }`,
      flex: 1
    },
    {
      headerName: "Leave Year",
      field: "leave_year",
      flex: 1
    },
    {
      headerName: "Paid Balance",
      valueGetter: (params) =>
        `${params.data.remaining_paid_leave_balance} / ${params.data.paid_leave_balance}`,
      flex: 1.2
    },
    {
      headerName: "Unpaid Balance",
      valueGetter: (params) =>
        `${params.data.remaining_unpaid_leave_balance} / ${params.data.unpaid_leave_balance}`,
      flex: 1.2
    },
    {
      headerName: "Carry Forward",
      field: "carry_forward_days",
      flex: 1
    },
    {
      headerName: "Total Leave Balance",
      valueGetter: (params) =>
        `${params.data.remaining_total_leave_balance} / ${params.data.total_leave_balance}`,
      flex: 1.2
    }
  ];

  return (
    <div>
      {/* Header and Year selector row */}
      <div className="label-card">
        <Row className="justify-content-between w-100 mb-3">
          <Col>
            <h3>Leave Balance List</h3>
          </Col>
          <Col>
            <div className="d-flex justify-content-end align-items-center mb-2">
              <Form.Group
                controlId="yearSelect"
                className="d-flex align-items-center"
              >
                <Form.Label className="me-2 fw-bold mb-0">
                  Select Year:
                </Form.Label>
                <Form.Select
                  size="sm"
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(parseInt(e.target.value))}
                  style={{ width: "150px", height: "30px", overflowY: "auto" }}
                >
                  {generateLeaveYears().map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </div>
          </Col>
        </Row>
      </div>

      {/* Export button */}
      {selectedRows.length > 0 && (
        <ExportButton
          gridRef={gridRef}
          fileName={`leave_balance_${selectedYear}.xlsx`}
          exportColumns={[
            "employee.employee_id",
            "employee_name",
            "leave_year",
            "remaining_paid_leave_balance",
            "paid_leave_balance",
            "remaining_unpaid_leave_balance",
            "unpaid_leave_balance",
            "carry_forward_days",
            "remaining_total_leave_balance",
            "total_leave_balance"
          ]}
        />
      )}

      {/* AG Grid Table */}
      <div className="ag-theme-material" style={{ height: "70vh" }}>
        <ReusableGrid
          rowData={filteredData}
          columnDefs={columnDefs}
          gridRef={gridRef}
          pagination={true}
          onSelectionChanged={(rows) => setSelectedRows(rows)}
        />
      </div>
    </div>
  );
};

export default LeaveBalanceList;

// import React, { useEffect, useState } from "react";
// import LeaveViewController from "../../redux/actions/leaveApiAction";
// import "../../styles/styles.css";
// import "../../styles/layout.css";
// import Table from "react-bootstrap/Table";
// import { useDispatch, useSelector } from "react-redux";
// import { Row, Col, Modal, Container, Form } from "react-bootstrap";

// const LeaveBalanceList =() => {

//     const dispatch = useDispatch();
//     const { getLeaveBalance } = LeaveViewController();
//     const { leaveBalance } = useSelector((state) => state.leave);
//     const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

//     useEffect(() => {
//         dispatch(getLeaveBalance());
//     }, []);

//     const generateLeaveYears = () => {
//       const currentYear = new Date().getFullYear();
//       const startYear = 2020; // or any logical lower limit
//       const years = [];
//       for (let year = currentYear; year >= startYear; year--) {
//         years.push(year);
//       }
//       return years;
//     };

//     return(
//         <div>
//         <div className="label-card">
//             <Row className="justify-content-between w-100">
//             <Col>
//             <h3>Leave Balance List</h3>
//             </Col>
//             <Col>
//             <div className="d-flex justify-content-end align-items-center mb-2">
//                     <Form.Group controlId="yearSelect" className="d-flex align-items-center">
//                       <Form.Label className="me-2 fw-bold mb-0">Select Year:</Form.Label>
//                       <Form.Select
//                         size="sm"
//                         value={selectedYear}
//                         onChange={(e) => setSelectedYear(parseInt(e.target.value))}
//                         style={{ width: '150px', height: '30px', overflowY: 'auto' }}

//                       >
//                         {generateLeaveYears().map((year) => (
//                           <option key={year} value={year}>{year}</option>
//                         ))}
//                       </Form.Select>
//                     </Form.Group>
//                   </div>
//             </Col>
//             </Row>
//         </div>

//         <Table striped bordered hover responsive="sm">
//         <thead>
//             <tr>
//                 <th>ID</th>
//                 <th>Employee</th>
//                 <th>Leave Year</th>
//                 <th>Remaining Leave Balance / Paid Leave Balance</th>
//                 <th>Remaining Leave balance / Unpaid Leave Balance</th>
//                 <th>Carry Forward Leave</th>
//                 <th>Remaining Leave Balance/Total Leaves</th>
//             </tr>
//         </thead>
//         <tbody>
//         {leaveBalance?.filter((balance) => balance.leave_year === selectedYear)
//            .map((balance) => {

//                 return (
//                   <tr key={balance.id}>
//                     <td>{balance.employee?.employee_id || "N/A"}</td>
//                     <td>{balance.employee.first_name} {balance.employee.last_name}</td>
//                     <td>{balance.leave_year}</td>
//                     <td>{balance.remaining_paid_leave_balance}/{balance.paid_leave_balance}</td>
//                     <td>
//                      {balance.remaining_unpaid_leave_balance}/{balance.unpaid_leave_balance}
//                     </td>
//                     <td>{balance.carry_forward_days}</td>
//                     <td> {balance.remaining_total_leave_balance}/{balance.total_leave_balance}</td> {/* Display Total Leaves */}
//                   </tr>
//                 );
//               })}
//             </tbody>
//           </Table>

//         </div>
//     );

// };

// export default LeaveBalanceList;
